import { ElMessage } from 'element-plus'
import { patientApi } from '@/shared/api'
import { AxiosErrorType, PatientType } from '@/shared/types'
import { showErrorMessage } from '@/shared/utils'
import { usePatientListing } from '@/shared/composables'

export const editPatient = async (patient: PatientType): Promise<boolean> => {
  const [error] = await patientApi.editPatient(patient)

  if (error) {
    const errors = Object.values(error).map(
      (message, index) => message[index]
    ) as string[]

    const axiosError: AxiosErrorType = {
      errors,
      status: error.status,
    }

    showErrorMessage(axiosError)

    return false
  }

  ElMessage({
    message: 'Данные обновлены',
    type: 'success',
  })

  const { updatePatientListing } = usePatientListing()

  updatePatientListing(true)

  return true
}
